import { error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchMainSliderAPI() {
    const response = await fetch(`${baseURL}/api/version3/sliders`);
    if(!response.ok) throw new error("Failed to retch main slider data");
    return response.json()
}